import React from "react";
import _ from "lodash";
import PlayIcon from "../../../assets/images/icon-circle-light-play-small@3x.png";
import { ItemWrapper, CategoryWrapper } from "./shared";

const SmallImageItem = ({ item }) => {
  const { title, name } = item;
  const imageUrl = _.get(item, "image_data.web_image");
  const videoData = _.get(item, "video_data");
  const category = _.chain(item)
    .get("category_data")
    .keys()
    .map(id => ({ id }))
    .first()
    .value();
  const styles = {
    container: {
      height: 170,
      width: 170,
      marginRight: 10
    },
    imageContainer: {
      width: "100%",
      height: 120,
      backgroundColor: "#D8D8D8",
      position: "relative"
    },
    image: {
      width: "100%",
      height: "100%",
      objectFit: "cover",
      borderRadius: 4,
      overflow: "hidden",
      position: "absolute",
      left: 0,
      top: 0
    },
    playIconContainer: {
      display: "flex",
      justifyContent: "center",
      width: "100%",
      height: "100%",
      position: "absolute",
      left: 0,
      top: 0
    },
    playIcon: {
      width: 50,
      height: 50,
      objectFit: "cover",
      alignSelf: "center"
    },
    categoryContainer: {
      height: 20,
      minWidth: 60,
      overflow: "hidden",
      borderRadius: 4,
      backgroundColor: "#FFFFFF",
      boxShadow: "0 6px 12px 0 rgba(15,14,17,0.05)",
      position: "absolute",
      left: 5,
      bottom: 5
    },
    category: {
      height: "100%",
      textAlign: "center",
      width: "100%",
      color: "#3F3E41",
      fontFamily: "PingFang TC, sans-serif",
      fontSize: 12,
      fontWeight: 600,
      letterSpacing: "0.43px",
      paddingLeft: 5,
      paddingRight: 5,
      boxSizing: "border-box"
    },
    titleContainer: {
      marginTop: 5,
      height: 36,
      width: "100%"
    },
    title: {
      color: "#6F6E70",
      fontFamily: "PingFang TC, sans-serif",
      fontSize: "13px",
      fontWeight: 600,
      letterSpacing: "0.54px",
      lineHeight: "18px"
    }
  };
  return (
    <div style={styles.container}>
      <div style={styles.imageContainer}>
        <img src={imageUrl} style={styles.image} alt="cover" />
        <div style={styles.categoryContainer}>
          <CategoryWrapper
            category={category}
            render={record => <div style={styles.category}>{record.name}</div>}
          />
        </div>
        {videoData && (
          <div style={styles.playIconContainer}>
            <img src={PlayIcon} style={styles.playIcon} alt="play" />
          </div>
        )}
      </div>
      <div style={styles.titleContainer}>
        <div style={styles.title}>{title || name}</div>
      </div>
    </div>
  );
};

const SmallImageItemBlock = props => {
  const { title, items } = props;
  const titleStyle = {
    color: "#0F0E11",
    fontFamily: "PingFang TC, sans-serif",
    fontSize: 18,
    fontWeight: 600,
    letterSpacing: "0.9px",
    lineHeight: "18px",
    marginBottom: 10
  };
  const itemContainerStyle = {
    display: "flex",
    flexDirection: "row",
    flexWrap: "norap"
  };
  const style = {
    width: "375px",
    boxSizing: "border-box",
    paddingBottom: 10,
    overflow: "auto"
  };
  return (
    <div style={style}>
      <div style={titleStyle}>{title}</div>
      <div style={itemContainerStyle}>
        {items.map(item => (
          <ItemWrapper
            key={item.id}
            item={item}
            render={record => <SmallImageItem item={record} />}
          />
        ))}
      </div>
    </div>
  );
};

export default SmallImageItemBlock;
